Drupal.behaviors.attach_tinySlider = {
  attach: function tinySliderInit(context, settings) {
    if (context.readyState === 'loading') {  // Loading hasn't finished yet
      context.addEventListener('DOMContentLoaded', () => {
         window.tSlider.init(document);
      });
    } else {  // `DOMContentLoaded` has already fired
      window.tSlider.init(context);
    }
	}
};

window.tSlider = {
  init: function(context) {
    for (var slideshow of context.querySelectorAll('.glide__slides')) {
      var slider = tns({
        container: slideshow,
        items: 1,
        controls: false,
        gutter: 50,
        center: true,
        fixedWidth: 568,
        viewportMax: 568,
        navPosition: "bottom",
        mouseDrag: true,
        autoplay: false,
        speed: 700,
        autoplayButton: false,
        responsive: {
          568: {
            fixedWidth: false,
            viewportMax: 1366,
          },
          1024: {
            controls: true
          },
          1366: {
            gutter: 0
          }
        }
      });
    }
    for (var node of document.querySelectorAll('.field--name-field-slide-button-link')) {
      node.querySelector('a').tabIndex = -1;
    }
    for (var slideshow of document.querySelectorAll('.tns-nav')) {
      slideshow.addEventListener('keydown', (event) => {
        if (event.key == "Enter") {
          document.querySelector('.view--slideshow').querySelector('.tns-slide-active').querySelector('a').click();
        }
      })
    }
  }
}
